/**
 * Created by Suhel Shrestha on 4/3/19
 */
import React from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import _ from 'lodash';

@inject('stationStore')
@observer
class ExportFilteredTable extends React.Component {

  @observable selectAll = false;

  render() {
    const { data, searchFilter, forCheckBox, onChangeCheck, stationStore } = this.props;
    let filteredStations = stationStore.items.filter(station => (
      (station &&
        station.name &&
        station.name.toLowerCase().indexOf(searchFilter) !== -1) ||

      (station &&
        station.tags &&
        station.tags.reduce((acc, tag) => {
          if (tag.name.toLowerCase().indexOf(searchFilter) !== -1) {
            return true;
          }
          return acc;
        }, false))
    ));

    return (
      <div className='DataTable'>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>
                <input type='checkbox' onChange={() => {
                  this.selectAll = !this.selectAll;
                  filteredStations.forEach((station) => {
                    const index = _.findIndex(data, item => item.level === 2 && item.data.id === station.id);
                    onChangeCheck(index, this.selectAll);
                  })
                }} />
              </th>
            </tr>
          </thead>
          <tbody>{filteredStations.map(station => {
            return (
              <tr>
                <td>{station.name}</td>
                <td>
                  <input
                    type="checkbox"
                    onChange={() => onChangeCheck(data.indexOf(data.find(item => item.level === 2 && item.data.id === station.id)))}
                    value={forCheckBox.find(cbitem => cbitem.stationId === station.id).selected}
                    checked={forCheckBox.find(cbitem => cbitem.stationId === station.id).selected}
                  />
                </td>
              </tr>
            )
          })}</tbody>
        </table>
      </div>
    )
  }
}

export default ExportFilteredTable;


// WEBPACK FOOTER //
// ./src/components/Folder/StationExport/ExportFilteredTable.js